const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const classNames = require('classnames');
const { connect } = require('react-redux');

// @ utils
const { formatText } = require('core/i18n').i18n;
const { formatAmount, formatCurrency } = require('utilities/currencyHelper');
const { toFirstUppercase } = require('utilities/stringHelper');
const SanitizeHelper = require('utilities/sanitizeHelper');
const storage = require('utilities/storage');

// @actions
const brokerNoStockAccountModalActions = require('actions/brokerNoStockAccountModal');

// @ commons
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const Flag = require('components/broker/commons/flag/flag');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @components
const BrokerMiFIDUSPersonButton = require('mifid/components/brokerMiFIDUSPersonButton/brokerMiFIDUSPersonButton');
const StockExchangeIndexVariation = require('components/broker/commons/stockExchange/stockExchangeIndexVariation.js');


//@constants
const { HYPHEN, BROKER_LARGE_FLAG_SIZE, BROKER_TYPE_STOCKS_NEW_DECIMALS, DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT, PRODUCT_TYPE_STOCKS } = require('constants/index');
const MICCODE_CONVERSION = require('constants/miccodes');

class BrokerAdvancedSearchStocksResultsRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleProductSelect = this.handleProductSelect.bind(this);
    }

    componentWillUnmount() {
        storage.localStorage.set(DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT, 1);
    }

    buildMarketLabel(miccode) {
        const market = MICCODE_CONVERSION.find(market => market.MIC == miccode);

        if (market) {
            const city = toFirstUppercase(market.CITY);
            return `${market.MIC}, ${city} (${market.ISO_COUNTRY_CODE})`;
        }

        return HYPHEN;
    }

    handleProductSelect() {
        const { item } = this.props;
        const product = {
            id: {
                isin: item.get('instrumentId'),
                iso: item.get('miccode')
            },
            label: item.get('instrument')
        };

        this.props.onHandleProductSelect(product);
    }

    render() {
        const {
            immStocksContracts,
            item,
            rowIndex,
            showModal,
            watchlistEnabled,
        } = this.props;
        const buyLabel = watchlistEnabled ? formatText(`broker-searchResultsWatchListBuyLabel`) : formatText(`broker-searchResultsBuyLabel`);
        const buyButtonSize = watchlistEnabled ? "compact" : "regular";
        const instrumentId = item.get('instrumentId');
        const miccode = item.get('miccode');
        const marketLabel = this.buildMarketLabel(miccode);
        const instrument = item.get('instrument');
        const currency = item.get('currencyCode');
        const price = `${formatAmount(item.get('last'), undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS)} ${formatCurrency(item.get('currencyCode'))}`
        const ytd = `${formatAmount(item.get('yearChangePercentage'))} %`;
        const countryCode = item.getIn(['country', 'id']);
        const buyUrl = `/myprofile/broker/stocksBuy/${instrumentId}/${miccode}`;
        const stockFileUrl = `/myprofile/broker/productFile/${instrumentId}/${miccode}`;
        const buttonText = 'Seleccionar';
        const watchlistId = item.get('watchlistId');
        const productKey = item.get('productKey');
        const emptyContracts = immStocksContracts.isEmpty();
        const starIconClasses = classNames('broker-search-results__star', {
            'broker-search-results__star--disabled': !watchlistId
        });

        let button;
        if (this.props.isModal) {
            button = (
                <OKButton modifier="secondary" onClick={this.handleProductSelect}>
                    {buttonText}
                </OKButton>);
        } else {
            if (emptyContracts) {
                button = (
                    <OKButton modifier="secondary" onClick={showModal}>
                        {buyLabel}
                    </OKButton>
                );
            } else {
                button = (
                    <BrokerMiFIDUSPersonButton modifier="secondary" onClick={() => this.props.onBuyClick(buyUrl)} size={buyButtonSize} isinId={instrumentId} marketId={miccode}>
                        {buyLabel}
                    </BrokerMiFIDUSPersonButton>);
            }
        }

        const watchlistButton = (
            <span>
                <OKButton
                    modifier="ghost"
                    size="small"
                    autoHeight={true}
                    onClick={() => { !watchlistId ? this.props.onWatchlistClick(instrumentId, miccode, PRODUCT_TYPE_STOCKS, productKey) : this.props.deleteProductFromList(watchlistId, instrumentId, miccode, instrument, watchlistId, false, PRODUCT_TYPE_STOCKS, productKey)}}
                >
                    <i className={starIconClasses}></i>
                </OKButton>
            </span>
        );

        const watchListToolTipInitialVal = Number(storage.localStorage.get(DISPLAY_WATCHLIST_TOOLTIP_BY_DEFAULT)) === 0;
        const isTooltipVisible = (rowIndex == 0 && watchListToolTipInitialVal && watchlistEnabled);
        const watchlistBtnTooltip = watchlistEnabled && (
            <OKTooltip
                target={watchlistButton}
                content="brokerWatchList-brokerWatchList_tooltip"
                isVisible={isTooltipVisible}
            />
        );

        const watchlistBtn = storage.localStorage.get(`watchlistTooltipFlag`) === 1 ? watchlistBtnTooltip : watchlistButton;
        return (
            <OKTableRow>
                <OKTableCell
                    className="broker-search-results__table-cell broker-search-results__table-first-column broker-search-results__table-cell--bold"
                >
                    <OKLink to={stockFileUrl}>
                        {SanitizeHelper.sanitizeData(instrument)}
                    </OKLink>
                </OKTableCell>
                <OKTableCell
                    className="broker-search-results__table-cell--price"
                    alignment="right"
                >
                    {price}
                </OKTableCell>
                <OKTableCell
                    className="broker-search-results__table-cell--market"
                    width="18%"
                >
                    <span className="broker-search-results__market-flag">
                        <Flag countryCode={countryCode} pixelsSize={BROKER_LARGE_FLAG_SIZE} />
                    </span>
                    {marketLabel}
                </OKTableCell>
                <OKTableCell width="3%">
                    {currency}
                </OKTableCell>
                <OKTableCell
                    className="broker-search-results__variation--stock"
                    alignment="right"
                >
                    <StockExchangeIndexVariation
                        variationPts={formatAmount(item.get('netChangePrice'), undefined, BROKER_TYPE_STOCKS_NEW_DECIMALS)}
                        variationPerc={formatAmount(item.get('netChangePercentage'))}
                    />
                </OKTableCell>
                <OKTableCell alignment="right">
                    {ytd}
                </OKTableCell>

                <OKTableCell
                    alignment="right"
                    className="broker-search-results__table-cell--action"
                >
                    <div className="broker-search-results__action-group">                        
                        {watchlistBtn}
                        {button}
                    </div>
                </OKTableCell>
            </OKTableRow>

        );
    }
}

BrokerAdvancedSearchStocksResultsRow.propTypes = {
    item: PropTypes.object,
    isModal: PropTypes.bool,
    onHandleProductSelect: PropTypes.func,
    onBuyClick: PropTypes.func,
    selectedType: PropTypes.string,
    onWatchlistClick: PropTypes.func,
    deleteProductFromList: PropTypes.func,
    immStocksContracts: PropTypes.object,
    showModal: PropTypes.func.isRequired,
    rowIndex: PropTypes.number,
    watchlistEnabled: PropTypes.bool
};

module.exports = {
    constructor: BrokerAdvancedSearchStocksResultsRow,
    BrokerAdvancedSearchStocksResultsRow: connect(
        state => ({
            immStocksContracts: state.brokerStocksContract

        }),{
            showModal: brokerNoStockAccountModalActions.showModal,
        })(BrokerAdvancedSearchStocksResultsRow)
};
